module.exports = __webpack_public_path__ + "img/12c3caa70af5ee5cc3f802a788171107.png";